import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// import {
//     UiOrderDetails,
//     UiOrderDetailsColWr,
//     UiOrderDetailsColName,
//     UiOrderDetailsColStatus,
//     UiOrderDetailsColValidUnit,
//     UiOrderDetailsColLabel,
//     UiOrderDetailsLastColWr,
//     UiOrderDetailsLastCol,
//     UiOrderDetailsLastColBtnWr,
//     UiVoucherDetailsWr,
// } from "../../../_uiComponents/common/UiProductElements";
import UiBarcode from "../../../../_uiComponents/common/UiBarcode";
import {
    UiCol,
    UiSingleRow,
    UiRowContainer,
} from "../../../../_uiComponents/grid-container/GridContainer";
// import VoucherWalletContent from "./VoucherWalletContent";
import { UiModal } from "../../../../_uiComponents/common/UiModal";
import {
    timeFormatUtcToLocal,
    kFormatter,
} from "../../../../../_helpers/support.services";
// import { orderStatus } from "../../../../_redux/_constants/";
// import {
//     UiBottomNavBar,
//     UiBottomNavBarItem,
// } from "../../../_uiComponents/common/UiBottomNavBar";

// import TodoIcon from "../../../../styles/img/bottom-nav-todo.png";
// import RewardsIcon from "../../../../styles/img/bottom-nav-rewards.png";
// import HelpIcon from "../../../../styles/img/help-icon.png";
// import BottomNavIcon from "../../../../styles/img/bottom-nav-campaigns.png";
import UiWalletCard from "../../../../_uiComponents/cards/UiWalletCard";
import { UiSlider } from "../../../../_uiComponents/common/UiSlider";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../../../../_uiComponents/common/UiSliderArrows";
import { shopVoucherWalletRequest, shopVoucherRedeemRequest } from "../../../../../_redux/_actions";
import { useSelector, useDispatch } from "react-redux";
// import copy from "copy-to-clipboard";
import { UiWalletZeroState } from "../../../../_uiComponents/cards/UiWalletZeroState";
import { UiWalletModal } from "../../../../_uiComponents/common/UiModal";
import {
    UiButtonPrimary,
    UiButtonIcon,
    UiButtonSecondary,
} from "../../../../_uiComponents/form/UiButton";
// import { UiVoucherLoading } from "../../../_uiComponents/common/UiLoadingSpinner";
import { useReactToPrint } from "react-to-print";
import GiftLogo from "../../../../../styles/img/gift-mall-logo.png";
// import { socket } from "../../../../../_helpers/support.services";
import { Rating } from 'react-simple-star-rating'
import CloseWhiteIcon from "../../../../../styles/img/close-white-icon.png";

export default function VoucherDetails(props) {
    const [showQrModal, setShowQrModal] = useState(false);
    const [showWalletModal, setWalletModal] = useState(false);
    const [copyText, setCopyText] = useState("");
    const [activeModal, setActiveModal] = useState(0);
    const [rating, setRating] = useState(0)


    const actionDispatch = useDispatch();


    const { voucherWallet } = useSelector((state) => {
        return {
            voucherWallet: state.shop.voucherWallet,
        };
    });

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        pageStyle: `@media print {
        
        }`,
        content: () => componentRef.current,
    });

    const [activeOrder, setActiveOrder] = useState(null);
    // useEffect(() => {
    //     // actionDispatch(shopVoucherWalletRequest());
    //     socket.send("sendSignalrTestMessage",() => {});

    //     socket.on("message", (data) => {
    //         // actionDispatch(shopVoucherWalletRequest());
    //         console.log(data);
    //     });

    //     return () => {
    //         console.log("------------------------")
    //         socket.off("message", () => {});
    //     };
    // }, []);

    const navigate = useNavigate();

    const showHideQr = (order) => {
        setActiveOrder(order);
        showQrModal ? setShowQrModal(false) : setShowQrModal(true);
    };
    
    const navigateUrl = (url) => {
        window.open(url, '_blank');
    }

    const UiMainSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3.75,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    dots: false,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ],
    };

    const [activeStep, setActiveStep] = useState([]);

    const redeemClick = (id) => {
        setActiveStep((current) => [...current, id]);
        actionDispatch(shopVoucherRedeemRequest({ id }));
    };
    const resetClick = (id) => {
        setActiveStep((current) => current.filter((item) => item !== id));
        actionDispatch(shopVoucherRedeemRequest({ id }));
    };
    const copyToClipboard = async (id) => {
        await navigator.clipboard.writeText(id);
    };

    const walletModalHide = () => {
        // setWalletModal(false);
        setActiveModal(0);
    };

    const handleModalClose = () =>{
        setActiveModal(0);
    }

    const showWalletModalClick = (orderId) => {
        setActiveModal(orderId);
        // setWalletModal(true);
    };

    const handleRating = (rate) => {
        setRating(rate)
    }

    return (
        <>
            <UiModal
                modalShowHide={showHideQr}
                show={showQrModal}
                title='Voucher Code'
            >
                {activeOrder && (
                    <UiSingleRow>
                        <UiBarcode value={activeOrder.cardNumber || ''} />
                        <UiBarcode value={activeOrder.pinNumber || ''} />
                    </UiSingleRow>
                )}                
            </UiModal>
            <div className="sb-wallet-slider">
                {voucherWallet.length > 0 ? (
                    <UiSlider UiSliderSettings={UiMainSlider}>
                        {voucherWallet.map((order, id) => (
                            <>
                                <div
                                    key={id}
                                    id={order.orderId}
                                    onClick={() => {
                                        showWalletModalClick(order.orderId);
                                    }}
                                >
                                    <UiRowContainer>
                                        <UiCol lg="12">
                                            <UiWalletCard
                                                key={id}
                                                title={order.orderName}
                                                points={kFormatter(
                                                    order.totalPoints,
                                                )}
                                                img={order.imageUrl}
                                                viewOrder={() =>
                                                    navigate(
                                                        "/app/shop/order-details/" +
                                                        order.orderId,
                                                    )
                                                }                                                
                                            />
                                        </UiCol>
                                    </UiRowContainer>
                                </div>

                                <UiWalletModal
                                    modalShowHide={walletModalHide}
                                    show={activeModal === order.orderId}
                                    title={order.orderName}
                                    points={kFormatter(order.totalPoints)}
                                // backdrop="static"
                                >
                                    <div
                                        ref={componentRef}
                                        className="sb-print-to-component"
                                    >
                                        
                                        <div className="sb-react-to-print">
                                            <h3>{order.orderName}</h3>
                                            <h4>
                                                {kFormatter(order.totalPoints)}
                                            </h4>
                                        </div>
                                        <div className="sb-react-to-print-img">
                                            <img src={order.imageUrl} />
                                        </div>
                                        <div className="sb-wallet-pin-no">
                                            Card #: {order.cardNumber} <br />
                                            Pin: {order.pinNumber}
                                        </div>
                                        
                                        <h5>Redeem online</h5>
                                        <p dangerouslySetInnerHTML={{ __html: order?.redemptionInfo }}></p>
                                        <h5>Redeem in store</h5>
                                        <p dangerouslySetInnerHTML={{ __html: order?.redemptionInfo }}></p>
                                        <h5>Terms and Conditions</h5>
                                        <p dangerouslySetInnerHTML={{ __html: order?.terms }}></p>

                                        <div className="sb-wallet-modal-footer">
                                            <UiButtonPrimary
                                                btnName="Print"
                                                onClick={handlePrint}
                                            />
                                            <div className="sb-wallet-redeem-btn-wr">
                                                <UiButtonPrimary
                                                    btnName="Redeem Online"
                                                    onClick={() =>
                                                        navigateUrl(order?.redemptionUrl)
                                                    }
                                                />
                                            </div>
                                            
                                            {activeStep.find(
                                                (element) =>
                                                    element === order.orderId,
                                            ) ? (
                                                <div className="sb-wallet-reset">
                                                    <UiButtonPrimary
                                                        btnName="Reset"
                                                        onClick={() =>
                                                            resetClick(
                                                                order.orderId,
                                                            )
                                                        }
                                                    />
                                                </div>
                                            ) : (
                                                <div className="sb-wallet-redeem">
                                                    
                                                    <UiButtonPrimary
                                                        btnName="Redeemd"
                                                        onClick={() =>
                                                            redeemClick(
                                                                order.orderId,
                                                            )
                                                        }
                                                    />
                                                </div>
                                            )}

                                            {(activeStep.find(
                                                (element) =>
                                                    element === order.orderId,
                                            ) || order.isRedeemed ) && (
                                                    <div className="sb-walletcard__redeemed">
                                                        <img src={CloseWhiteIcon} onClick={handleModalClose}/>
                                                        <h4>Redeemed</h4>
                                                        <div className="sb-walletcard__rating">
                                                            <h5>Rate this voucher </h5>
                                                            <Rating
                                                                initialValue={rating}
                                                                onClick={handleRating} />
                                                            <div className="ratingcontent">
                                                                Rate how much you like this voucher so that others can benefit from your experience.
                                                            </div>
                                                        </div>

                                                    </div>
                                                )}
                                        </div>
                                        <div className="sb-wallet-modal-footer-bottom sb-shop-spend-in-store-btn">
                                            <UiButtonPrimary
                                                btnName="Spend in Store"
                                                onClick={() =>
                                                    showHideQr(order)
                                                }
                                            />
                                        </div>
                                        {(order.orderStatus === 5 || order.orderStatus === 1) && (
                                            <div className="sb-walletcard__preparing">
                                                <div className="sb-voucher-loader-content">
                                                    <div className="loader"></div>
                                                    <h3>
                                                        We're preparing <br />
                                                        your voucher
                                                    </h3>
                                                    <h5>
                                                        Please wait a few more
                                                        seconds
                                                    </h5>
                                                </div>
                                            </div>
                                        )}

                                        <div className="sb-footer-logo-section">
                                            <div className="sb-footer-logo-section__left">
                                                <img src={GiftLogo} />
                                                <h5>
                                                    Powered by Gift Card Mall
                                                </h5>
                                            </div>
                                            <div className="sb-footer-logo-section__right">
                                                <h5>
                                                    {" "}
                                                    © 2023 GiftCardMall.com
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </UiWalletModal>
                            </>
                        ))}
                    </UiSlider>
                ) : (
                    <UiWalletZeroState />
                )}
            </div>

            {/* <UiVoucherLoading voucherLoader={false} /> */}

            <div id="product"></div>
            {/* <UiVoucherDetailsWr>
                <UiOrderDetails>
                    <UiSingleRow>
                        <UiCol lg="4">
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Order Number" />
                                <UiOrderDetailsColLabel
                                    label={props.order.orderNumber}
                                />
                            </UiOrderDetailsColWr>
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Date" />
                                <UiOrderDetailsColLabel
                                    label={timeFormatUtcToLocal(
                                        props.order.orderDate,
                                    )}
                                />
                            </UiOrderDetailsColWr>
                        </UiCol>
                        <UiCol lg="4">
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Order Name" />
                                <UiOrderDetailsColLabel
                                    label={props.order.orderName}
                                />
                            </UiOrderDetailsColWr>
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Points Total" />
                                <UiOrderDetailsColLabel
                                    label={kFormatter(props.order.totalPoints)}
                                />
                            </UiOrderDetailsColWr>
                        </UiCol>
                        <UiCol lg="4">
                            <UiOrderDetailsLastColWr>
                                <UiOrderDetailsLastCol>
                                    <UiOrderDetailsColWr>
                                        <UiOrderDetailsColName colName="Status" />
                                        <UiOrderDetailsColStatus
                                            status={
                                                props.order.orderStatus ==
                                                orderStatus.COMPLETED
                                                    ? "Completed"
                                                    : props.order.orderStatus ==
                                                      orderStatus.EXPIRED
                                                    ? "Expired"
                                                    : props.order.orderStatus ==
                                                      orderStatus.FAILED
                                                    ? "Failed"
                                                    : "Ordered"
                                            }
                                        />
                                    </UiOrderDetailsColWr>
                                    <UiOrderDetailsColWr>
                                        <UiOrderDetailsColName colName="Valid Unit" />
                                        <UiOrderDetailsColValidUnit
                                            validUnit={timeFormatUtcToLocal(
                                                props.order.expiryDate,
                                            )}
                                        />
                                    </UiOrderDetailsColWr>
                                </UiOrderDetailsLastCol>
                                <UiOrderDetailsLastColBtnWr>
                                    <UiButtonPrimary
                                        onClick={() =>
                                            navigate(
                                                "/app/shop/order-details/" +
                                                    props.order.orderId,
                                            )
                                        }
                                        btnName="View Order"
                                        size="45"
                                    />
                                </UiOrderDetailsLastColBtnWr>
                            </UiOrderDetailsLastColWr>
                        </UiCol>
                    </UiSingleRow>
                </UiOrderDetails>
                <div className="p-3">
                    <UiSingleRow>
                        <UiCol lg="4" xl="4">
                            <img
                                src={props.order.imageUrl}
                                className="img-fluid sb-product-info-img sb-product-info-lg"
                            />
                        </UiCol>
                        <UiCol lg="8" xl="8">
                            <VoucherWalletContent
                                showHideQr={showHideQr}
                                order={props.order}
                            />
                        </UiCol>
                    </UiSingleRow>
                </div>
            </UiVoucherDetailsWr> */}
            {/* <UiBottomNavBar>

                <UiBottomNavBarItem
                    navIcon={BottomNavIcon}
                    navTitle="Product"
                    hash="product"
                />
                <UiBottomNavBarItem
                    navIcon={HelpIcon}
                    navTitle="Help"
                    hash=""
                />

            </UiBottomNavBar> */}
        </>
    );
}
